import {
  NotificationReceiverProfile,
  NotificationReceiverProfileEntity
} from "../../../model/notification-receiver-profile";
import {makeEntitySelectors} from "../base-entity-store";
import {NotificationChannel} from "../../../model/notification-channel";
import {createParamSelector} from "../../../util/selector-util";
import {getDatabaseCodeSafely} from "../../../model/database-code";

export interface NotificationReceiverProfileSelectorProps {
  channel?: NotificationChannel | string
}

const getChannelParam = createParamSelector<NotificationReceiverProfileSelectorProps | undefined, NotificationChannel | string | undefined>(params => params?.channel);

const filter = (v: NotificationReceiverProfile, props: NotificationReceiverProfileSelectorProps) => {
  if (props?.channel) {
    if (v.channel !== getDatabaseCodeSafely(props.channel)) {
      return false
    }
  }

  return true
}

const notificationReceiverProfileSelectors = makeEntitySelectors<
  NotificationReceiverProfile,
  NotificationReceiverProfileEntity,
  NotificationReceiverProfileSelectorProps
>({
  defaultProps: {},

  filter: filter,

  transform: (value) => NotificationReceiverProfileEntity.from(value),
});

export const notificationReceiverProfilesSelector =
  (props?: NotificationReceiverProfileSelectorProps) =>
    notificationReceiverProfileSelectors.listSelectorWithParams(
      [getChannelParam],
      (channel) => ({
        ...props,
        channel
      }),
    );

export const notificationReceiverProfileSelector =
  () => notificationReceiverProfileSelectors.singleSelector();
